import '../styles/NotFound.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <img src="/assets/logo.png" alt="Success" style={{ width: '200px', marginBottom: '20px' }} />
      <h1>Halaman Tidak Ditemukan</h1>
      <span>Maaf, halaman yang Anda cari tidak tersedia.</span>
    </div>
  );
}

export default NotFoundPage;